import { AnyAction } from 'redux'
import { FETCH_CAREER, FETCH_POSITION_DETAILS } from '../actions/types'

export interface CareerItem {
  id: number
  title: string
  location: string
  description: string
  group: string
}

export interface CareerProps {
  data: {
    بازاریابی: CareerItem[]
    'طراحی محصول': CareerItem[]
    'پشتیبانی مشتریان': CareerItem[]
    'عملیات میزبان': CareerItem[]
  }
  details: CareerItem
}

export const careerReducer = (
  state: CareerProps = { details: {} as any, data: {} as any },
  action: AnyAction,
) => {
  switch (action.type) {
    case FETCH_CAREER:
      return { ...state, data: action.data }

    case FETCH_POSITION_DETAILS:
      return { ...state, details: action.payload }

    default:
      return state
  }
}
